<script>
import { mapState } from 'vuex'
import MemberBookingDetails from '@components/member-booking-details'

export default {
  page: {
    title: 'BookingHistory',
    meta: [{ name: 'description', content: 'Booking History' }],
  },

  components: { MemberBookingDetails },

  props: {
    property: { type: Object, required: true },
    histories: { type: Array, required: true },
  },

  data: () => ({
    tableHeaders: [
      { text: 'ID', value: 'id' },
      { text: 'Booked On', value: 'bookedOn' },
      { text: 'Stay Period', value: 'stayPeriod' },
      { text: 'Status', value: 'status' },
    ],
    wording: {
      guest: [
        { text: 'Title', value: 'title' },
        { text: 'First name', value: 'firstName' },
        { text: 'Last name', value: 'lastName' },
        { text: 'Email', value: 'email' },
      ],
      payment: [
        { text: 'Type', value: 'type' },
        { text: 'Number', value: 'number' },
        { text: 'Name on card', value: 'nameOnCard' },
        { text: 'Exp', value: 'expiredDate' },
      ],
      transaction: [
        { text: 'Total', value: 'total' },
        { text: 'Tax', value: 'tax' },
        { text: 'Service', value: 'service' },
        { text: 'Grand total', value: 'grandTotal' },
      ],
    },
    showDetail: false,
    item: {},
  }),

  computed: {
    ...mapState('auth', { user: 'currentUser' }),
  },

  watch: {
    showDetail(val) {
      if (!val) this.item = {}
    },
  },

  methods: {
    onHistoryClick(history) {
      this.showDetail = true
      this.item = history
    },
  },
}
</script>

<template>
  <section class="mt-6">
    <div class="container container-page mx-auto px-6">
      <div class="flex flex-wrap">
        <div class="w-full mb-6">
          <div class="border border-gray-500 rounded-sm">
            <div class="overflow-hidden relative">
              <div
                class=" overflow-y-auto scrollbar-w-2 scrollbar-track-grey-lighter scrollbar-thumb-rounded scrollbar-thumb-grey scrolling-touch"
              >
                <table class="w-full text-left table-collapse">
                  <thead>
                    <tr>
                      <th
                        v-for="header in tableHeaders"
                        :key="header.value"
                        class="text-sm font-medium text-grey p-2 bg-grey-lightest"
                      >
                        {{ header.text }}
                      </th>
                    </tr>
                  </thead>
                  <tbody class="align-baseline bg-gray-100">
                    <tr v-if="!histories.length">
                      <td :colspan="tableHeaders.length" class="text-center">
                        No booking history yet
                      </td>
                    </tr>
                    <template v-else>
                      <tr
                        v-for="history in histories"
                        :key="history.id"
                        class="cursor-pointer hover:bg-gold-500 hover:text-white"
                        @click="onHistoryClick(history)"
                      >
                        <td
                          class="p-2 border-t border-grey-light whitespace-no-wrap"
                        >
                          {{ history.id }}
                        </td>
                        <td
                          class="p-2 border-t border-grey-light whitespace-no-wrap"
                        >
                          {{ history.bookedOn }}
                        </td>
                        <td
                          class="p-2 border-t border-grey-light whitespace-no-wrap"
                        >
                          {{ history.stayPeriod }}
                        </td>
                        <td
                          class="p-2 border-t border-grey-light whitespace-no-wrap"
                        >
                          {{ history.status }}
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <MemberBookingDetails v-model="showDetail" :booking="item" />
    </div>
  </section>
</template>
